import { StandaloneComponent } from '@/types/component';

export const StandaloneDirektBanner: StandaloneComponent = () => null;
